var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownloadButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 31 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.235 12.594a.81.81 0 00-1.154 0l-6.765 6.83V.824A.82.82 0 0015.5 0a.82.82 0 00-.816.824v18.6l-6.765-6.83a.81.81 0 00-1.154 0 .83.83 0 000 1.165l8.158 8.235a.81.81 0 001.154 0l8.158-8.235a.829.829 0 000-1.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.553 28H2.447C1.097 28 0 26.892 0 25.53v-3.295a.82.82 0 01.816-.823.82.82 0 01.816.823v3.294a.82.82 0 00.815.824h26.106a.82.82 0 00.815-.824v-3.294a.82.82 0 01.816-.823.82.82 0 01.816.823v3.294C31 26.892 29.902 28 28.553 28z"
  }))));
}

export default SvgArrowDownloadButton;